import constants from "../../constants";
import authenService from "../../services/authenService";
import errorMessageFilter from "../../filters/errorMessageFilter";
import utils from "../../services/utils";

export default {
  data() {
    return {
      isUploading: false
    };
  },

  computed: {
    uploadAttachmentURL() {
      return constants.BASE_SERVICE_URL + "attachment/uploadFile";
    },

    uploadAttachmentHeaders() {
      let header = {};
      let idToken = authenService.getIdToken();
      idToken && (header["Authorization"] = "Bearer " + idToken);
      var userDeptRoleId = authenService.get(
        constants.STORAGE_KEY.USER_DEPT_ROLE_ID
      );
      userDeptRoleId &&
      (header[constants.HTTP_HEADER_KEY.USER_DEPT_ROLE_ID] = userDeptRoleId);
      return header;
    }
  },

  methods: {
    onUploadSuccess(response) {
      this.isUploading = false;
      return new Promise(resolve => resolve(response));
    },

    onUploadError() {
      this.isUploading = false;
      this.$message({
        message: errorMessageFilter({errorCode: "file.uploadFail"}),
        type: "error"
      });
    },

    validateUploadFile(file, options, messageErr) {
      !options && (options = {});

      let fileExt = utils.getFileExt(file);

      //validate file type;
      let type = file.type;
      let acceptFileTypes = options.acceptFileTypes;
      if (!acceptFileTypes || !acceptFileTypes.length) {
        acceptFileTypes = constants.DEFAULT_ACCEPTED_CONTENT_TYPE;
      }
      let blackListExtensions =
        options.blackListExtensions || constants.DEFAULT_BLACK_LIST_EXTS;
      if (
        (acceptFileTypes.indexOf(type) === -1 &&
          acceptFileTypes.indexOf(
            constants.DEFAULT_ACCEPTED_CONTENT_TYPE_ALL
          ) === -1) ||
        blackListExtensions.indexOf(fileExt) !== -1
      ) {
        this.$message({
          message:
            messageErr ||
            errorMessageFilter({
              errorCode: "file.invalidFileType"
            }),
          type: "error"
        });
        return false;
      }

      //validate file size;
      let size = file.size;
      let maxFileSize = options.acceptFileSize;
      !maxFileSize && (maxFileSize = constants.DEFAULT_MAX_FILE_SIZE_MB);
      if (size > maxFileSize * 1024 * 1024) {
        this.$message({
          message: errorMessageFilter({
            errorCode: "file.invalidFileSize",
            params: [maxFileSize]
          }),
          type: "error"
        });
        return false;
      }
      this.isUploading = true;
      return true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/doc-in/uploadFileMixin.js